import Onboarding from './component';

export default Onboarding;
